import React from "react";
import clsx from "clsx";

type HeroIcon = React.ComponentType<React.SVGProps<SVGSVGElement>>;
type Colour = "gray" | "orange" | "yellow" | "green" | "purple" | "red" | "blue";

const iconHoverMap: Record<Colour, string> = {
  gray: "group-hover:text-gray-700",
  orange: "group-hover:text-orange-600",
  yellow: "group-hover:text-yellow-600",
  green: "group-hover:text-green-600",
  purple: "group-hover:text-purple-600",
  red: "group-hover:text-red-600",
  blue: "group-hover:text-blue-600",
};

export default function ActionButton({
  label,
  colour = "gray",
  onClick,
  disabled,
  selected,
  Icon,
}: {
  label: string;
  colour?: Colour;
  onClick: () => void;
  disabled?: boolean;
  selected?: boolean;
  Icon?: HeroIcon;
}) {
  const iconHoverClass = iconHoverMap[colour];

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={clsx(
        "group bg-white px-4 py-2 rounded-lg shadow flex items-center gap-2",
        "transition-transform duration-100 hover:duration-200 hover:scale-110",
        selected ? "scale-110" : "",
        disabled ? "opacity-50 pointer-events-none hover:scale-100" : "cursor-pointer"
      )}
    >
      {Icon && (
        <Icon
          className={clsx(
            "h-5 w-5 text-gray-400 transition-colors",
            disabled ? "" : iconHoverClass
          )}
        />
      )}
      <span className="text-sm">{label}</span>
    </button>
  );
}